import toast from "react-hot-toast";

const throwMessage = (type, message) => {
  const options = { duration: 1500 };

  switch (type) {
    case "info":
      toast(message, options);
      break;
    case "success":
      toast.success(message, options);
      break;
    case "warning":
      toast(message, { ...options, icon: "⚠️" });
      break;
    case "error":
      toast.error(message, options);
      break;
    default:
      break;
  }
};
export default throwMessage;
